import { useRef, useEffect } from 'react';
import { useChatDemo } from './useChatDemo';

export default function ChatWindow({ startDemo }) {
  const bodyRef = useRef(null);
  const { runDemoChat, clearDemo } = useChatDemo();
  const demoStarted = useRef(false);

  useEffect(() => {
    if (startDemo && !demoStarted.current && bodyRef.current) {
      demoStarted.current = true;
      runDemoChat(bodyRef.current);
    }
  }, [startDemo, runDemoChat]);

  useEffect(() => {
    return () => clearDemo();
  }, [clearDemo]);

  return (
    <div className="win">
      <div className="win-head">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="logo" style={{ fontSize: '18px', color: 'var(--primary)' }}>nebula</span>
          <span style={{ fontSize: '10px', fontWeight: 700, color: '#C2410C', background: '#FEF3C7', border: '1px solid #FDE68A', padding: '2px 7px', borderRadius: '100px', letterSpacing: '.04em' }}>MAX</span>
        </div>
        <div className="live"><span className="ldot"></span>Đang hoạt động</div>
      </div>
      <div className="chat-body" ref={bodyRef} style={{ paddingTop: '20px', paddingBottom: '20px' }} />
    </div>
  );
}
